import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getIsDiffuseOptimizationOnAsync } from "./diffuseOptimizationApi";
import { resetSiteSpecificData } from "../app/store/GlobalActions";
import { beginRequest, completeRequest, rejectRequest, RequestState } from "../app/store/RequestState";
import { LoadingState } from "../app/LoadingState";

interface DiffuseOptimizationState extends RequestState {
  isDiffuseOptimizationOn: boolean;
  siteId: string;
}

const initialState: DiffuseOptimizationState = {
  loadingState: LoadingState.None,
  isDiffuseOptimizationOn: false,
  siteId: "",
};

export const diffuseOptimizationSlice = createSlice({
  name: "diffuseOptimization",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDiffuseOptimizationStatus.fulfilled, (state, action) => {
        if (state.siteId !== action.meta.arg || !completeRequest(state, action.meta.requestId)) {
          return;
        }
        state.isDiffuseOptimizationOn = action.payload.isActive;
      })
      .addCase(getDiffuseOptimizationStatus.pending, (state, action) => {
        const nextState =
          state.siteId === action.meta.arg ? state : { ...initialState, siteId: action.meta.arg };
        beginRequest(nextState, action.meta.requestId);
        return nextState;
      })
      .addCase(getDiffuseOptimizationStatus.rejected, (state, action) => {
        rejectRequest(state, action);
      })
      .addCase(resetSiteSpecificData, () => initialState);
  },
});

export const getDiffuseOptimizationStatus = createAsyncThunk(
  "diffuseOptimization/fetchStatus",
  async (siteId: string, { signal }) => {
    const isActive = await getIsDiffuseOptimizationOnAsync(siteId, signal);
    return {
      siteId,
      isActive,
    };
  }
);

export const diffuseOptimizationReducer = diffuseOptimizationSlice.reducer;
